import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { IconWrapper } from "@insite/mobius/Icon";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useEmblaCarousel from "embla-carousel-react";
import React, { createRef, FC, useEffect } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { css, ThemeProps, withTheme } from "styled-components";

interface Memberlist {
    fields: {
        title: string;
        subtitle: string;
        videourl: string;
        maintitle: string;
    };
}

const enum fields {
    videos = "videos",
    heading = "heading",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.videos]: Memberlist[];
        [fields.heading]: string;
    };
    maxNumberOfColumns: number;
    maintitle: string;
}
type Props = OwnProps & ThemeProps<BaseTheme> & HasShellContext;

export interface Imgstyle {
    container?: InjectableCss;
    twrapper?: InjectableCss;
    subtitlestyle?: InjectableCss;
    parentDiv?: GridContainerProps;
    prevArrowWrapper?: InjectableCss;
    buttonPREV?: InjectableCss;
    ImageAndSpecialwrapper?: InjectableCss;
    main?: InjectableCss;
    nextArrowWrapper?: InjectableCss;
    buttonNEXT?: InjectableCss;
    button?: LinkPresentationProps;
    Maintitle?: InjectableCss;
    parentContainer?: InjectableCss;
    wrapper?: InjectableCss;
    Box?: InjectableCss;
    headerDiv?: InjectableCss;
    heading?: InjectableCss;
}

export const imgstyle: Imgstyle = {
    Box: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
    buttonPREV: {
        css: css`
            padding: 0;
            span {
                background-color: ${getColor("primary.contrast")};
                svg {
                    color: ${getColor("text.accent")};
                    background-color: ${getColor("primary.contrast")};
                }
            }
        `,
    },
    buttonNEXT: {
        css: css`
            padding: 0;
            span {
                svg {
                    color: ${getColor("text.accent")};
                }
            }
        `,
    },
    heading: {
        css: css`
            font-style: normal;
            font-size: 24px;
            text-align: center;
            text-transform: capitalize;
            color: ${getColor("secondary")};
            margin-bottom: 30px;
            margin-top: 30px;
            font-family: "Roboto-Bold";

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 18px;
                        margin-bottom: 15px;
                    `,
                    css`
                        margin-top: 18px;
                        margin-bottom: 15px;
                    `,
                    css`
                        margin-top: 18px;
                        margin-bottom: 15px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    prevArrowWrapper: {
        css: css`
            height: 10px;
            position: absolute;
            z-index: 1;
            top: 60%;
            left: 0px;
            > button[class^="ButtonWrapper"] {
                background-color: ${getColor("primary.contrast")};
                border: 1px solid ${getColor("primary.contrast")};
                outline: none;
                svg {
                    background-color: ${getColor("primary.contrast")};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        > button[class^="ButtonWrapper"] {
                            position: relative;
                            right: 20px;
                            background: none;
                            border: none;
                            ${IconWrapper} {
                                background: none;
                            }
                            svg {
                                background: none;
                            }
                        }
                    `,
                    null,
                    null,
                    null,
                    null,
                ])};
        `,
    },
    nextArrowWrapper: {
        css: css`
            position: absolute;
            z-index: 1;
            top: 60%;
            right: 0px;
            > button[class^="ButtonWrapper"] {
                background-color: ${getColor("primary.contrast")};
                border: 1px solid ${getColor("primary.contrast")};
                outline: none;
                svg {
                    background-color: ${getColor("primary.contrast")};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        > button[class^="ButtonWrapper"] {
                            position: relative;
                            left: 20px;
                            background: none;
                            border: none;
                            ${IconWrapper} {
                                background: none;
                            }
                            svg {
                                background: none;
                            }
                        }
                    `,
                    null,
                    null,
                    null,
                    null,
                ])};
        `,
    },
    twrapper: {
        css: css`
            text-align: left;
            text-transform: capitalize;
            margin-top: 15px;
            font-size: 18px;
            font-weight: 600;
        `,
    },

    subtitlestyle: {
        css: css`
            text-align: left;
            text-transform: capitalize;
            margin-top: 15px;
            font-size: 13px;
            color: ${getColor("text.accent")};
            font-family: inherit;
            margin-bottom: 12px;
        `,
    },

    parentContainer: {
        css: css`
            position: relative;
            padding: 0;
            width: 100%;
            padding: 0px 10px;
            flex: 0 0 auto;
        `,
    },
    parentDiv: {
        css: css`
            display: flex;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 50%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                ])};
        `,
    },
    container: {
        css: css`
            overflow: hidden;
            width: 100%;
        `,
    },
    wrapper: {
        css: css`
            position: relative;
            max-width: 100%;
            margin-left: auto;
            margin-right: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    css`
                        padding: 0;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    css`
                        padding: 0;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    ImageAndSpecialwrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            position: relative;
            iframe {
                height: 389px;
            }
        `,
    },
    main: {
        css: css`
            position: relative;
            width: 100%;
            /* max-width: 1240px !important; */
            margin: 0 auto;
            padding: 0px 40px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])};
        `,
    },
    headerDiv: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            justify-content: center;
            align-items: center;
        `,
    },
};

const styles = imgstyle;

export const SEHomePageVideoCarousel: FC<Props> = ({
    fields,
    maxNumberOfColumns = fields.videos.length,
    theme,
    shellContext,
}) => {
    const afterCarousel = createRef<HTMLSpanElement>();

    const [emblaRef, embla] = useEmblaCarousel();

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [windowResizeTime, setWindowResizeTime] = useState(0);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);
    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    const getSlidesToScroll = useCallback(() => {
        // const maxNumberOfColumns = fields.videos.length || 6;

        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 1;
        } else {
            localSlidesToScroll = 3;
        }
        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, [maxNumberOfColumns]);

    const [slidesToScroll, setSlidesToScroll] = useState(getSlidesToScroll());

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    const [draggable, setDraggable] = useState(getDraggable());

    useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);

        const newDraggable = getDraggable();
        setDraggable(newDraggable);
    }, [maxNumberOfColumns, windowResizeTime]);

    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);

        const onWindowResize = () => {
            setWindowResizeTime(Date.now());
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, [embla]);
    const onWindowResize = () => {
        setWindowResizeTime(Date.now());
    };
    React.useEffect(() => {
        onWindowResize();
    }, []);

    React.useEffect(() => {
        if (!embla || !fields.videos || fields.videos.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            loop: fields.videos.length > slidesToScroll,
            // loop: fields.videos.length > slidesToScroll,
        });
        setCanScroll();
    }, [embla, slidesToScroll, draggable, fields.videos]);

    if (!fields.videos || fields.videos.length === 0) {
        return null;
    }
    return (
        <>
            <StyledWrapper
                css={css`
                    opacity: 1;
                    position: relative;
                    margin: 0 auto;
                    /* padding-top: 30px; */
                    padding-right: 3px;
                    /* padding-bottom: 43px; */
                    padding-left: 3px;
                    background-color: ${getColor("primary.contrast")};
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                padding: 0px;
                                padding-bottom: 20px;
                            `,
                            css`
                                padding: 0px;
                                padding-bottom: 20px;
                            `,
                            css`
                                padding: 0px;
                                padding-bottom: 20px;
                            `,
                            null,
                            null,
                        ])}
                `}
            >
                <StyledWrapper {...styles.main}>
                    <StyledWrapper>
                        <StyledWrapper {...styles.headerDiv}>
                            <StyledWrapper as="h2" {...styles.heading}>
                                {" "}
                                {fields.heading}{" "}
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...styles.Box}></StyledWrapper>
                        <StyledWrapper>
                            {fields.videos.length > 1 && (
                                <StyledWrapper
                                    {...styles.prevArrowWrapper}
                                    style={{
                                        display: `${slidesToScroll >= fields.videos.length ? "none" : "block"}`,
                                    }}
                                >
                                    <Button
                                        {...styles.buttonPREV}
                                        onClick={() => {
                                            embla && embla.scrollPrev();
                                        }}
                                        disabled={!canScrollPrev}
                                    >
                                        <ButtonIcon src={ChevronLeft} />
                                    </Button>
                                </StyledWrapper>
                            )}
                            <StyledWrapper
                                {...styles.nextArrowWrapper}
                                style={{
                                    display: `${slidesToScroll >= fields.videos.length ? "none" : "block"}`,
                                }}
                            >
                                <Button
                                    {...styles.buttonNEXT}
                                    onClick={() => {
                                        embla && embla.scrollNext();
                                    }}
                                    disabled={!canScrollNext}
                                >
                                    <ButtonIcon src={ChevronRight} />
                                </Button>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>

                    <StyledWrapper {...styles.wrapper}>
                        <StyledWrapper {...styles.container} ref={emblaRef}>
                            <StyledWrapper {...styles.parentDiv}>
                                {fields.videos
                                    ?.slice(0)
                                    .reverse()
                                    .map((videos, index) => {
                                        return (
                                            <>
                                                <StyledWrapper
                                                    {...styles.parentContainer}
                                                    style={{ width: `calc(100% / ${slidesToScroll})` }}
                                                    key={index}
                                                >
                                                    <StyledWrapper
                                                        css={css`
                                                            width: 100%;
                                                            height: 100%;
                                                            position: relative;
                                                            display: flex;
                                                            flex-direction: column;
                                                        `}
                                                    >
                                                        <StyledWrapper {...styles.ImageAndSpecialwrapper}>
                                                            <iframe
                                                                id="videoID"
                                                                // width="400"
                                                                // height="315"
                                                                src={videos.fields.videourl}
                                                                frameBorder="0"
                                                                allowFullScreen
                                                            ></iframe>
                                                        </StyledWrapper>
                                                        <StyledWrapper {...styles.twrapper}>
                                                            {videos.fields.title}
                                                        </StyledWrapper>
                                                        <StyledWrapper {...styles.subtitlestyle}>
                                                            {videos.fields.subtitle}
                                                        </StyledWrapper>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </>
                                        );
                                    })}
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withIsInShell(withTheme(SEHomePageVideoCarousel)),
    definition: {
        group: "Basic",
        displayName: "SE Home Page Video Carousel",
        fieldDefinitions: [
            {
                name: fields.heading,
                displayName: "Heading",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                placeholder: "text placeholder",
                sortOrder: 0,
            },

            {
                name: fields.videos,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { title } }) => title || "title",
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "videourl",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "subtitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
